import { render, staticRenderFns } from "./jidu.vue?vue&type=template&id=3da2acfc&scoped=true&"
import script from "./jidu.vue?vue&type=script&lang=js&"
export * from "./jidu.vue?vue&type=script&lang=js&"
import style0 from "./jidu.vue?vue&type=style&index=0&id=3da2acfc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da2acfc",
  null
  
)

export default component.exports